/**
 * useHealthIssues — the organization's current health issues, built from the notifications
 * stream, and whether they may be out of date.
 */

import { useAtomValueRawSync } from 'jotai';

import { healthIssuesAtom, healthIssuesStaleAtom } from '@/state/api/healthMessagesAtoms';
import type { FeedHealthMessage } from '@/types/healthMessages';

interface HealthIssues {
    issues: FeedHealthMessage[];
    /** The stream is down: an issue may have ended unseen. */
    isStale: boolean;
}

export function useHealthIssues(): HealthIssues {
    return {
        issues: useAtomValueRawSync(healthIssuesAtom),
        isStale: useAtomValueRawSync(healthIssuesStaleAtom),
    };
}
